import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
// import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from 'primereact/inputswitch';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { selectCurrentEmpid } from '../../../pages/login/authSlice';
// import { GoalHeader } from './GoalHeader';
import { datetimeToDate } from '../../../utils/dateFormat';
import { useGetDirectReporteesQuery } from '../coachingHistoryGrid/coachingHistoryGridSlice';
import { useCreateRevGenCoachingGoalMutation } from './revGenSlice';
import './revgen.scss';

interface CascadeGaolSettingProps {
    visible: boolean;
    goalDeatails: any;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    inputMonth: number;
    inputYear: number;
}

export const CascadeGaolSetting = (props: CascadeGaolSettingProps) => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [directReportee, setDirectReportee] = useState<any>([]);
    const [CreateCoachingGoal] = useCreateRevGenCoachingGoalMutation();
    const [includeHierarchy, setIncludeHierarchy] = useState(false);

    const { data: directReporteeData } = useGetDirectReporteesQuery(
        { employeeNo: parseInt(loggedEmpNum, 10), includeHierarchy },
        { skip: !loggedEmpNum }
    );
    useEffect(() => {
        if (directReporteeData?.data?.length > 0) {
            const data = directReporteeData?.data?.map((item: any) => {
                return {
                    ...item,
                    name: item.employee_name,
                };
            });
            setDirectReportee(data);
        } else {
            setDirectReportee([]);
        }
    }, [directReporteeData, includeHierarchy]);

    const handleSave = () => {
        const request = {
            authorId: props.goalDeatails.author_employee_number,
            employeeId: selectedGoalSettings.map((item: any) => item.employee_number.toString()).join(','),
            month: props.inputMonth,
            year: props.inputYear,
            goalTitle: props.goalDeatails.goal_title,
            goalDate: datetimeToDate(props.goalDeatails.goal_date),
            goalDescription: props.goalDeatails.goal_description,
        };
        CreateCoachingGoal(request)
            .unwrap()
            .then((res: any) => {
                if (res?.status) {
                    if (res?.statusCode === 500) {
                        toast.error('Server Error');
                    } else {
                        if (res?.message === 'Success') {
                            toast.success('Goal Cascaded successfully');
                            props.setVisible(false);
                        }
                        if (res?.message === 'Error') {
                            const data = res?.data;
                            if (data.item2) toast.warn(data.item2);
                            if (data.item3) toast.warn(data.item3);
                        }
                    }
                } else toast.error('Something went wrong');
            })
            .catch((error: any) => {
                toast.error(error);
            });
    };
    const [selectedGoalSettings, setSelectedGoalSettings] = useState<any>([]);

    return (
        <Dialog
            header={`Cascading Goals - ${props.goalDeatails.goal_title}`}
            visible={props.visible}
            style={{ width: '50vw' }}
            onHide={() => props.setVisible(false)}
        >
            {/* <GoalHeader setNewGoal={handleSetNewGoal} inputMonth={inputMonth} inputYear={inputYear} isNewGoal={isNewGoal} hideNewGoalBtnPayoutTextbox={hideNewGoalBtnPayoutTextbox} /> */}
            <div className="d-flex justify-content-between align-items-center mt-1">
                <div className="d-flex align-items-center">
                    <span className="me-2 metricbargraph">Reports</span>
                    <InputSwitch
                        checked={includeHierarchy}
                        onChange={(e) => setIncludeHierarchy(e.value)}
                        style={{ marginTop: '0.3rem' }}
                    />
                    <span className="ms-2 metricbargraph">Direct Reports</span>
                </div>
            </div>
            <DataTable
                value={directReportee}
                selectionMode="checkbox"
                rows={5}
                scrollable
                scrollHeight="250px"
                style={{ minWidth: '10rem' }}
                rowsPerPageOptions={[5, 10, 25, 50]}
                paginator={directReportee?.length > 5}
                selection={selectedGoalSettings}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                dataKey="employee_number"
                onSelectionChange={(e) => setSelectedGoalSettings(e.value)}
            >
                <Column selectionMode="multiple" />
                <Column header="Select all" field={'name'} />
            </DataTable>
            <div className="mt-2">
                <div
                    className="col-md-4"
                    style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}
                >
                    <Button
                        label="Cancel"
                        // style={{ fontWeight: 400 }}
                        className="btn-secondary me-2"
                        onClick={() => {
                            props.setVisible(false);
                        }}
                    />
                    <Button label="Save" disabled={selectedGoalSettings.length === 0} onClick={handleSave} className="btn-primary" />
                </div>
            </div>
        </Dialog>
    );
};
